var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowDownIntoBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9165 7.99984C1.9165 6.84896 2.84896 5.9165 3.99984 5.9165C4.41405 5.9165 4.74984 6.25229 4.74984 6.6665C4.74984 7.08072 4.41405 7.4165 3.99984 7.4165C3.67738 7.4165 3.4165 7.67738 3.4165 7.99984V12.6665C3.4165 12.989 3.67738 13.2498 3.99984 13.2498H11.9998C12.3223 13.2498 12.5832 12.989 12.5832 12.6665V7.99984C12.5832 7.67738 12.3223 7.4165 11.9998 7.4165C11.5856 7.4165 11.2498 7.08072 11.2498 6.6665C11.2498 6.25229 11.5856 5.9165 11.9998 5.9165C13.1507 5.9165 14.0832 6.84896 14.0832 7.99984V12.6665C14.0832 13.8174 13.1507 14.7498 11.9998 14.7498H3.99984C2.84896 14.7498 1.9165 13.8174 1.9165 12.6665V7.99984Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00049 11.0833C7.58627 11.0833 7.25049 10.7475 7.25049 10.3333L7.25049 1.66658C7.25049 1.25237 7.58628 0.916585 8.00049 0.916585C8.4147 0.916585 8.75049 1.25237 8.75049 1.66658L8.75049 10.3333C8.75049 10.7475 8.4147 11.0833 8.00049 11.0833Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00073 11.0833C7.8018 11.0833 7.611 11.0042 7.47034 10.8636L5.47034 8.86358C5.17744 8.57069 5.17744 8.09581 5.47034 7.80292C5.76323 7.51003 6.2381 7.51003 6.531 7.80292L8.00058 9.2725L9.46958 7.80301C9.76243 7.51007 10.2373 7.50999 10.5302 7.80283C10.8232 8.09568 10.8233 8.57055 10.5304 8.86349L8.53109 10.8635C8.39044 11.0042 8.19966 11.0832 8.00073 11.0833Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownIntoBox);
export default __webpack_public_path__ + "static/media/icon-arrow-down-into-box.6db7d6c8db7732ead73d2524a412276f.svg";
export { ForwardRef as ReactComponent };